import BigNumber from 'bignumber.js';

// export type LiquidationStatus = 'Safe' | 'Cautious' | 'Critical';
export enum LiquidationStatus {
  Safe = 'Safe',
  Cautious = 'Cautious',
  Critical = 'Critical',
}

const LIQUIDATION_STATUS_THRESHOLD = {
  Safe: 0.2,
  Cautious: 0.1,
  Critical: 0.05,
};

const getLiqStatusPriceDelta = (liqPrice: BigNumber) => {
  return {
    safeLiqPrice: liqPrice.multipliedBy(LIQUIDATION_STATUS_THRESHOLD.Safe),
    cautiousLiqPrice: liqPrice.multipliedBy(
      LIQUIDATION_STATUS_THRESHOLD.Cautious,
    ),
    criticalLiqPrice: liqPrice.multipliedBy(
      LIQUIDATION_STATUS_THRESHOLD.Critical,
    ),
  };
};

export const getLiquidationStatus = (
  liquidationPrice: BigNumber,
  marketPrice: BigNumber,
): LiquidationStatus | undefined => {
  const { safeLiqPrice, cautiousLiqPrice } =
    getLiqStatusPriceDelta(liquidationPrice);

  const marketLiquidationPriceDeltaAbs = marketPrice
    .minus(liquidationPrice)
    .abs();

  if (marketLiquidationPriceDeltaAbs.isGreaterThanOrEqualTo(safeLiqPrice)) {
    return LiquidationStatus.Safe;
  } else if (
    marketLiquidationPriceDeltaAbs.isGreaterThanOrEqualTo(cautiousLiqPrice)
  ) {
    return LiquidationStatus.Cautious;
  } else {
    return LiquidationStatus.Critical;
  }
};
